import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type NecesitaPreguntarPorEarlyArrivalResponse = {
  value: boolean;
};

type NecesitaPreguntarPorEarlyArrivalParams = {
  oidVisita: number;
  fecha: string;
};

export const necesitaPreguntarPorEarlyArrival = async (
  query: NecesitaPreguntarPorEarlyArrivalParams
): Promise<NecesitaPreguntarPorEarlyArrivalResponse['value']> => {
  try {
    const res = await apiClient.post<NecesitaPreguntarPorEarlyArrivalResponse>(
      Endpoints.NecesitaPreguntarPorEarlyArrival,
      {
        oidVisita: query.oidVisita,
        fechaIngreso: query.fecha,
      }
    );

    return res?.data?.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
